import { FC, useMemo } from 'react';
import CardList from '../CardList';
import {
  CommonAttributesProps,
  VariantsChildrenType,
} from 'screens/AccessExpressV3/accessExpress.types';
import { formatMobilityPrice } from 'screens/AccessExpressV3/utils';

interface PricingProps extends CommonAttributesProps {
  variants: VariantsChildrenType[];
  selected: VariantsChildrenType | null;
  setSelected: (v: VariantsChildrenType, index?: number) => void;
}

export const getPricingOptionTitle = (variant: VariantsChildrenType) => {
  if (variant.productGroupDesc === 'FINANCED')
    return `Finance - ${variant.contractTerm_Months} months`;

  return 'Purchase';
};

const Pricing: FC<PricingProps> = ({
  handleStep,
  step,
  variants,
  selected,
  setSelected,
}) => {
  const onSelect = (item: VariantsChildrenType, index?: number) => {
    handleStep && handleStep(step ?? 1);
    setSelected(item, index);
  };

  const options = useMemo(
    () =>
      variants.map((variant) => ({
        id: variant.id,
        title: getPricingOptionTitle(variant),
        body: `$${formatMobilityPrice(variant?.originalPrice)} ${
          variant.productGroupDesc === 'FINANCED' ? '/month' : ''
        }`,
        item: { ...variant },
      })),
    [variants],
  );

  return (
    <>
      <CardList
        title="Choose pricing option"
        selected={selected?.id || null}
        onClick={(item, index) => onSelect(item as VariantsChildrenType, index)}
        options={options}
      />
    </>
  );
};

export default Pricing;
